import { Typography } from 'components/generic/typography';
import type { HtmlHTMLAttributes } from 'react';
import styled from 'styled-components';
import type { PriceModuleProps, Size } from './shared/types';

const RecommendedPriceStyle = styled(Typography.Body)`
    color: ${({ theme }) => theme.ColorTextSecondary};
`;

type RecommendedPriceProps = {
    recommendedPrice: PriceModuleProps['recommendedPriceLabel'];
    size: Size;
} & HtmlHTMLAttributes<HTMLSpanElement>;

export function RecommendedPrice({ recommendedPrice, size, className }: RecommendedPriceProps) {
    return (
        <RecommendedPriceStyle forwardedAs="span" size={size === 'lg' ? 'M' : 'S'} className={className}>
            {recommendedPrice}
        </RecommendedPriceStyle>
    );
}
